<template>

    <MenuSiModuleMain/>
    <MenuSiConfiguration/>
<!--    <HeadingAppointments/>-->

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>User Settings</h3>

<!--                    <div class="grid">-->
<!--                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">-->
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->

                    <div class="field">
                        <label for="username">Username</label>
                        <InputText id="username" type="text" :disabled="true" v-model.trim="profile.username"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" type="text" :disabled="true" v-model.trim="profile.email"/>
                    </div>

                    <div class="field">
                        <label for="mobile">Mobile</label>
                        <InputText id="mobile" type="text" :disabled="true" v-model.trim="profile.mobile"/>
                    </div>

                    <div class="field">
                        <label for="location">Location</label>
                        <Dropdown v-model="userConfiguration.siLocation" :options="locations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Region"/>
                    </div>

                    <div class="field">
                        <label for="plan">Plan</label>
                        <Dropdown v-model="userConfiguration.siPlan" :options="plans" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Account Type"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUs">Access to US Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiUs" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableCa">Access to Canadian Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiCa" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUk">Access to UK Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiUk" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableZa">Access to South African Stock Market?</label>
                        <Dropdown v-model="userConfiguration.enableSiZa" :options="confirmations" :disabled="true"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="siEnableUk">Access to SI Course?</label>
                        <InputText id="courseRights" type="text" :disabled="true" v-model.trim="courseRights"/>
                    </div>

                    <div class="field">
                        <span class="p-column-title">&nbsp;</span>
                    </div>

                    <h3>Subscription Cancellation</h3>
                    <div class="field">
                        <label for="siActiveSubscription">Subscription Status</label>
                        <InputText
                            id="siActiveSubscription"
                            type="text"
                            :disabled="true"
                            :value="subscriptionStatusLabel"/>
                    </div>

                    <Button v-show="userConfiguration.siActiveSubscription === 'Y'" label="Process Cancellation"
                            class="mr-2 mb-2" :loading="submitted" @click="processCancellation"></Button>

                    <div v-show="userConfiguration.siActiveSubscription === 'Y'" class="field">
                        <span class="p-column-title">Turning off auto-renew will turn off your subscription at your next renewal date.</span>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiConfiguration from "@/components/menu/simodule/MenuSiConfiguration.vue";
import ClientService from "@/service/ClientService";

export default {
    components: {
        MenuSiConfiguration,
        SiFooter,
        MenuSiModuleMain
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    computed: {
        subscriptionStatusLabel() {
            return this.userConfiguration.siActiveSubscription === "Y"
                ? "Active"
                : "Cancelled";
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[Configuration][mounted] Data = ", userData);
            console.log("[Configuration][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[Configuration][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Configuration][mounted] userConfigData.data = ", userConfigData.data);

            if ((this.profile.rights === 'C') || (this.profile.rights === 'A')) {
                this.courseRights = "Yes"
            } else {
                this.courseRights = "No"
            }

        } catch (e) {
            console.error("[Configuration][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[Configuration][mounted] this.userConfiguration = ", this.userConfiguration);
    },
    data() {

        return {
            profile: {},
            submitted: false,
            userConfiguration: {},
            companyConfiguration: {},
            courseRights: "No",
            confirmations: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Other', code: 'O'}
            ],
        }
    },
    methods: {
        callOverview() {
            this.$router.push("siOverview");
        },
        async processCancellation() {
            this.submitted = true;

            try {
                const response = await ClientService.processCancellationSiClient(this.profile.companyId, this.profile.email);
                console.log("[Configuration][processCancellation] Processed cancellation. Response = [].", response)

                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Processed cancellation',
                    life: 3000
                });
            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to process cancellation. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.submitted = false;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
